define([
    'origEdge/quoteandbind/common/models/CovTerm',
], (OotbCovTerm) => {

    const CovTerm = Object.create(OotbCovTerm);

    /**
     * Calls OOTB CovTerm.create(), returns an object that inherits from this
     * and adds basler specific properties. The new object is frozen like the OOTB one.
     *
     * Added Properties:
     * <dl>
     *     <dt>isEditable : Boolean</dt>
     *     <dd>
     *         Whether the CovTerm is editable or not
     *         according to the IsEditable property introduced in the TermDTO in PC
     *     </dd>
     * </dl>
     *
     * @param model
     * @param loading
     * @param onChange
     */
    CovTerm.create = function (model, loading, onChange) {
        const base = OotbCovTerm.create(model, loading, onChange);
        const baslerCovTerm = Object.create(base, { //BaslerCovTerm has not all attributes; If a attribute is missing append it here
            isEditable: {
                value: model.isEditable,
            },
            isVisibleInEdit: {
                value: model.isVisibleInEdit,
            },
            isVisibleInOverview: {
                value: model.isVisibleInOverview,
            },
            patternCode: {
                value: model.patternCode,
            },
        });
        return Object.freeze(baslerCovTerm);
    };

    return CovTerm;
});


// WEBPACK FOOTER //
// ./app/customer/js/src/edge/quoteandbind/common/models/CovTerm.js